<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">选择商品</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding:20px">

<!--        <div style="padding-bottom: 5px;">-->
<!--          <el-select size="mini" v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">-->
<!--            <el-option-->
<!--                v-for="item in arr_business"-->
<!--                :key="item.businessCode"-->
<!--                :label="item.businessName"-->
<!--                :value="item.businessCode">-->
<!--            </el-option>-->
<!--          </el-select>-->

<!--          <el-button type="primary" plain size="mini" icon="el-icon-search" @click="getGoods(true)">搜索</el-button>-->
<!--        </div>-->

        <el-table :data="goodsInfo" class="table" border height="400">
          <el-table-column prop="name" fixed label="标题" ></el-table-column>
<!--          <el-table-column prop="price" label="销售价"></el-table-column>-->
<!--          <el-table-column label="类型">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.goodsType == 2">单独服务</span>-->
<!--              <span v-if="scope.row.goodsType == 3">合并服务</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleAddOrder(scope.$index, scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

    <WriteSelectTime ref="mySelectTime" v-show="showModalAddOrder"
                     v-on:closeAddOrder="closeAddOrder" v-on:getCart2="getCart2"></WriteSelectTime>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import WriteSelectTime from "../Business/WriteSelectTime"

export default {
  name: 'GetGood',
  data() {
    return {
      showModalAddOrder:false,
      loading: false,

      elderly:'',
      elderlyCode:'',

      goodsInfo:[],
      totalItems:0,
      pageSize:20,
      pageIndex:1,

      arr_business:[],
      businessCode:'',

    }
  },
  components:{
    WriteSelectTime
  },
  methods: {
    init(elderlyCode){
      this.elderlyCode = elderlyCode;
      this.getBusiness();
    },
    closeSelf() {
      this.$emit("closeGoods");
    },


    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {

              this.arr_business = [];
              let arr = response.data.data;
              for(let i=0;i<arr.length;i++){
                if(arr[i].businessType == 6){
                  this.arr_business.push(arr[i]);
                }
              }

              //this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getGoods();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },


    getCart2(){
      this.$emit("getCart");
    },

    current_change:function(currentPage){
      this.pageIndex = currentPage;
      this.getGoods();
    },
    getGoods(isSearch){

      if(isSearch)this.pageIndex = 1;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/PageForBusinessNormalDisable",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          businessCode:this.businessCode,
          pageSize:this.pageSize,
          pageIndex:this.pageIndex,

          status:-1,
          name:'',
          goodsClassGovernmentCode:'',
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.goodsInfo=response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },



    handleAddOrder(index, row) {
      this.$refs.mySelectTime.init(row,this.elderlyCode);
      this.showModalAddOrder = !this.showModalAddOrder;
    },
    closeAddOrder:function(){
      this.showModalAddOrder = !this.showModalAddOrder;
    },


  }
}


</script>


